<!-- BlogWrapper.vue -->
<template>
    <div>
      <router-view />  <!-- 这里会渲染嵌套的 Blog 组件 -->
    </div>
</template>
  
  <script>
  export default {
    name: 'BlogWrapper',
  };
  </script>
  